import { identify, makeRequest, Service } from '../../../utils/http';

type Data = {
  id: string;
};

export async function deleteOrderApi({ id }: Data) {
  return makeRequest(Service.deleteOrder(id, await identify()));
}
